import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Api from "./utils/apiCall";
import { API_URLS } from "./apis/urls";

export interface INocTravel {
    id: number;
    travel_id: string;
    travel_title: string;
    sapCreatedAt?: string;
    sapModifiedAt?: string;
}

interface INocTravelState {
    data: INocTravel[];
    loading: boolean;
    error: string | null;
    total: number;
    page: number;
    limit: number;
}

const initialState: INocTravelState = {
    data: [],
    loading: false,
    error: null,
    total: 0,
    page: 1,
    limit: 10,
};

export const getAllNocTravel = createAsyncThunk(
    "nocTravel/getAll",
    async (payload: { query: string; page: number; limit: number }, thunkAPI) => {
        try {
            const response = await Api.post(API_URLS.MASTERS.FIND_ALL_NOC_TRAVEL, payload);
            return response.data;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
        }
    }
);

const nocTravelSlice = createSlice({
    name: "nocTravel",
    initialState,
    reducers: {
        resetNocTravelState: (state) => {
            state.data = [];
            state.loading = false;
            state.error = null;
            state.total = 0;
            state.page = 1;
            state.limit = 10;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllNocTravel.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getAllNocTravel.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload.data.data || [];
                state.total = action.payload.data.total || 0;
                state.page = action.payload.data.page || 1;
                state.limit = action.payload.data.limit || 10;
            })
            .addCase(getAllNocTravel.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
                state.data = [];
            });
    },
});

export const { resetNocTravelState } = nocTravelSlice.actions;
export default nocTravelSlice.reducer;
